import request, { ResponseData } from '@/utils/request'

export async function fetReminds(params): Promise<ResponseData<any>> {
  return request('/api/v1/remind/list', {
    method: 'get',
    params,
  })
}

export async function addNotifyRule(params): Promise<ResponseData<any>> {
  return request('/api/v1/notify_rule/add', {
    method: 'post',
    data: {
      ...params,
      qt_mark: false,
    },
  })
}

export async function getNotifyRule(): Promise<ResponseData<any>> {
  return request('/api/v1/notify_rule/list', {
    method: 'post',
    data: {
      qt_mark: false,
    },
  })
}

export async function deleteNotifyRule(params): Promise<ResponseData<any>> {
  return request('/api/v1/notify_rule/delete', {
    method: 'post',
    data: {
      ...params,
      qt_mark: false,
    },
  })
}

export async function updateNotifyRule(params): Promise<ResponseData<any>> {
  return request('/api/v1/notify_rule/update', {
    method: 'post',
    data: {
      ...params,
      qt_mark: false,
    },
  })
}

export async function getNotifyRobot(): Promise<ResponseData<any>> {
  return request('/api/v1/notify_robot/search', {
    method: 'post',
    data: { qt_mark: false },
  })
}

export async function deleteNotifyRobot(params: { id: string }): Promise<ResponseData<any>> {
  return request('/api/v1/notify_robot/delete', {
    method: 'post',
    data: {
      ...params,
      qt_mark: false,
    },
  })
}

export async function addOrUpdateNotifyRobot(params): Promise<ResponseData<any>> {
  return request('/api/v1/notify_robot/modify', {
    method: 'post',
    data: {
      ...params,
      qt_mark: false,
    },
  })
}

export async function getQcRules(params): Promise<ResponseData<any>> {
  return request('/api/v1/qc_rule/rule_with_notify', {
    method: 'post',
    data: params,
  })
}

export async function getQcGroups(params): Promise<ResponseData<any>> {
  return request('/api/v1/qc_norm/groups', {
    method: 'post',
    data: params,
  })
}

export async function getSnickTree(params): Promise<ResponseData<any>> {
  return request('/api/v1/department/snick_tree', {
    method: 'post',
    data: params,
  })
}
